import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { IoChevronDown } from 'react-icons/io5';
import { navItems } from './MainNav';

function Mobilemenu({ onClose }) {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (label) => {
    setOpenDropdown((current) => (current === label ? null : label));
  };

  return (
    <nav className="ma-mobile-nav" aria-label="Mobile navigation">
      <ul className="ma-mobile-nav-list">
        {navItems.map((item) =>
          item.children ? (
            <li key={item.label} className="ma-mobile-nav-item">
              <button
                type="button"
                className={`ma-mobile-nav-link ma-mobile-nav-link--dropdown${
                  openDropdown === item.label ? ' ma-mobile-nav-link--open' : ''
                }`}
                onClick={() => toggleDropdown(item.label)}
                aria-expanded={openDropdown === item.label}
              >
                {item.label}
                <IoChevronDown className="ma-mobile-nav-chevron" aria-hidden="true" />
              </button>
              {openDropdown === item.label && (
                <ul className="ma-mobile-submenu">
                  {item.children.map((child) => (
                    <li key={child.label}>
                      {child.to ? (
                        <Link
                          to={child.to}
                          className="ma-mobile-submenu-link"
                          onClick={onClose}
                        >
                          {child.label}
                        </Link>
                      ) : (
                        <span className="ma-mobile-submenu-link ma-mobile-submenu-link--static">
                          {child.label}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ) : item.to ? (
            <li key={item.label} className="ma-mobile-nav-item">
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  `ma-mobile-nav-link${isActive ? ' ma-mobile-nav-link--active' : ''}`
                }
                end={item.to === '/home'}
                onClick={onClose}
              >
                {item.label}
              </NavLink>
            </li>
          ) : (
            <li key={item.label} className="ma-mobile-nav-item">
              <span className="ma-mobile-nav-link ma-mobile-nav-link--static">{item.label}</span>
            </li>
          )
        )}
      </ul>
    </nav>
  );
}

export default Mobilemenu;
